import * as React from 'react';
import { Paragraph } from '../../../../elements';
import TwoColRow from './TwoColRow';
const ExtendedFinancialMappingRow = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    value.description ? (React.createElement(React.Fragment, null,
        React.createElement(Paragraph, null, i18n('common.extendedFinancialMappingsDefaultText')),
        React.createElement("br", null),
        React.createElement(TwoColRow, { label: `${i18n('common.description')}:`, value: value.description }))) : (React.createElement(React.Fragment, null,
        React.createElement(Paragraph, null, i18n('common.extendedFinancialMappingsDefaultText')),
        React.createElement("br", null),
        React.createElement(Paragraph, null, i18n('common.noExtendedFinancialMappings')))),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.taxAgency')} (${formatDate(value.verificationDate)})` }),
    value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default ExtendedFinancialMappingRow;
